import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import routes from '../../../routes';
import {
  LOCAL_STORE_AUTH_TOKEN
} from '../../../constants/constants';
import ErrorBoundary from '../error-boundary/error-boundary.component';

const PrivateRoute = ({ component: Component, ...rest }) => (

  <Route
    {...rest}
    render={props => (
      localStorage.getItem(LOCAL_STORE_AUTH_TOKEN)
        ? <ErrorBoundary><Component {...props} /></ErrorBoundary>
        : <Redirect to={routes.authentication} />
    )}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.shape({}).isRequired,
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/common/components/private-route/private-route.component.js